"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatColumnSettingsWizardSection = exports.renderFormatColumnSettingsSummary = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const FormLayout_1 = tslib_1.__importStar(require("../../../components/FormLayout"));
const CheckBox_1 = require("../../../components/CheckBox");
const Tabs_1 = require("../../../components/Tabs");
const OnePageAdaptableWizard_1 = require("../../Wizard/OnePageAdaptableWizard");
const Tag_1 = require("../../../components/Tag");
const ToggleGroup_1 = require("../../../components/Toggle/ToggleGroup");
const Toggle_1 = require("../../../components/Toggle/Toggle");
let alignmentOptions = [
    { value: 'Left', label: 'Left' },
    { value: 'Right', label: 'Right' },
    { value: 'Center', label: 'Center' },
];
const renderFormatColumnSettingsSummary = (data) => {
    var _a;
    return (React.createElement(rebass_1.Box, { padding: 2 },
        React.createElement(rebass_1.Text, null,
            "Cell alignment ",
            React.createElement(Tag_1.Tag, null, (_a = data.CellAlignment) !== null && _a !== void 0 ? _a : 'default')),
        React.createElement(rebass_1.Text, { mt: 3 },
            "Include grouped rows ",
            React.createElement(Tag_1.Tag, null, data.IncludeGroupedRows ? 'yes' : 'no'))));
};
exports.renderFormatColumnSettingsSummary = renderFormatColumnSettingsSummary;
const FormatColumnSettingsWizardSection = (props) => {
    const { data } = (0, OnePageAdaptableWizard_1.useOnePageAdaptableWizardContext)();
    const onCellAlignmentSelectChanged = (CellAlignment) => {
        const newData = Object.assign(Object.assign({}, data), { CellAlignment });
        if (CellAlignment === null) {
            delete newData.CellAlignment;
        }
        props.onChange(newData);
    };
    const onIncludeGroupedRowsChanged = (IncludeGroupedRows) => {
        props.onChange(Object.assign(Object.assign({}, data), { IncludeGroupedRows }));
    };
    return (React.createElement(Tabs_1.Tabs, null,
        React.createElement(Tabs_1.Tabs.Tab, null, "Settings"),
        React.createElement(Tabs_1.Tabs.Content, null,
            React.createElement(rebass_1.Flex, { flexDirection: "row" },
                React.createElement(FormLayout_1.default, null,
                    React.createElement(FormLayout_1.FormRow, { label: "Cell Alignment" },
                        React.createElement(ToggleGroup_1.ToggleGroup, null,
                            React.createElement(Toggle_1.Toggle, { icon: "align-left", pressed: data.CellAlignment === 'Left', onPressedChange: (pressed) => pressed
                                    ? onCellAlignmentSelectChanged('Left')
                                    : onCellAlignmentSelectChanged(null) }),
                            React.createElement(Toggle_1.Toggle, { icon: "align-center", pressed: data.CellAlignment === 'Center', onPressedChange: (pressed) => pressed
                                    ? onCellAlignmentSelectChanged('Center')
                                    : onCellAlignmentSelectChanged(null) }),
                            React.createElement(Toggle_1.Toggle, { icon: "align-right", pressed: data.CellAlignment === 'Right', onPressedChange: (pressed) => pressed
                                    ? onCellAlignmentSelectChanged('Right')
                                    : onCellAlignmentSelectChanged(null) }))),
                    React.createElement(FormLayout_1.FormRow, { label: "Include Grouped Rows:" },
                        React.createElement(rebass_1.Flex, { alignItems: "center", marginLeft: 2 },
                            React.createElement(CheckBox_1.CheckBox, { "data-name": "include-grouped-rows-checkbox", checked: data.IncludeGroupedRows, onChange: onIncludeGroupedRowsChanged, mr: 2 }))))))));
};
exports.FormatColumnSettingsWizardSection = FormatColumnSettingsWizardSection;
